import {Directive, HostBinding, Input} from "@angular/core";
import {AbstractControl} from "@angular/forms";

@Directive({
  selector: '[vbValidatable]',
})
export class ValidatableDirective {

  @Input('vbValidatable')
  control: AbstractControl;

  @HostBinding('class.has-success')
  public get hasSuccess(): boolean {
    return (this.control && this.control.dirty && this.control.valid);
  }

  @HostBinding('class.has-error')
  public get hasError(): boolean {
    return (this.control && this.control.dirty && this.control.invalid);
  }

  @HostBinding('class.has-warning')
  public get hasWarning(): boolean {
    return (this.control && this.control.pristine && this.control.invalid);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/directives/validatable.directive.ts